/* ============================================================
   Kaizen Seven — Homepage v3 "Modern line grid"
   Motion: hero stagger, scroll reveals, chart draw-in, parallax.
   All states are applied by JS so content stays visible without it,
   and everything is gated behind prefers-reduced-motion.
   ============================================================ */
(function () {
  'use strict';

  if (window.__K7V3_INIT__) return;
  window.__K7V3_INIT__ = true;

  function init() {
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ease = 'cubic-bezier(0.16, 1, 0.3, 1)';

    /* Newsletter: swap the button label to SUBSCRIBED while the form posts */
    document.querySelectorAll('[data-k7-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('[data-k7-subscribe]');
        if (btn) btn.textContent = btn.getAttribute('data-k7-subscribed-label') || 'Subscribed';
      });
    });

    if (reduced) return;

    /* Hero stagger: lines rise into place on load */
    var lines = document.querySelectorAll('[data-k7-stagger]');
    if (lines.length) {
      lines.forEach(function (el) {
        el.style.transform = 'translateY(110%)';
        el.style.opacity = '0';
      });
      void document.body.offsetHeight;
      setTimeout(function () {
        lines.forEach(function (el, i) {
          el.style.transition = 'transform 1.1s ' + ease + ' ' + (i * 130) + 'ms, opacity 0.8s ease ' + (i * 130) + 'ms';
          el.style.transform = 'translateY(0)';
          el.style.opacity = '1';
        });
      }, 60);
      /* One-shot failsafe: no matter what, hero lines end up visible */
      setTimeout(function () {
        lines.forEach(function (el) {
          if (el.style.opacity !== '1') {
            el.style.transition = 'none';
            el.style.transform = 'translateY(0)';
            el.style.opacity = '1';
          }
        });
      }, 1500);
    }

    /* Hero photo: soft light follows cursor + localized liquid distortion */
    var heroHost = document.querySelector('.k7-hero3a');
    var heroLight = document.querySelector('[data-k7-hero-light]');
    if (heroHost && heroLight) {
      var disp = document.getElementById('k7disp');
      var distorted = document.querySelector('[data-k7-hero-distort]');
      var dTarget = 0, dCurrent = 0, lastX = 0, lastY = 0, heroRaf = null;
      var heroTick = function () {
        dTarget *= 0.92;
        dCurrent += (dTarget - dCurrent) * 0.12;
        if (disp) disp.setAttribute('scale', dCurrent.toFixed(2));
        if (dCurrent > 0.05 || dTarget > 0.05) {
          heroRaf = requestAnimationFrame(heroTick);
        } else {
          if (disp) disp.setAttribute('scale', '0');
          heroRaf = null;
        }
      };
      heroHost.addEventListener('mousemove', function (e) {
        var r = heroHost.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width * 100).toFixed(1);
        var y = ((e.clientY - r.top) / r.height * 100).toFixed(1);
        heroLight.style.background = 'radial-gradient(560px circle at ' + x + '% ' + y + '%, rgba(255,255,255,0.85), rgba(255,255,255,0) 70%)';
        heroLight.style.opacity = '1';
        if (distorted) {
          var mask = 'radial-gradient(300px circle at ' + x + '% ' + y + '%, #000 0%, rgba(0,0,0,0.6) 55%, transparent 100%)';
          distorted.style.webkitMaskImage = mask;
          distorted.style.maskImage = mask;
          distorted.style.opacity = '1';
        }
        var speed = Math.hypot(e.clientX - lastX, e.clientY - lastY);
        lastX = e.clientX; lastY = e.clientY;
        dTarget = Math.min(dTarget + speed * 0.3, 12);
        if (!heroRaf) heroRaf = requestAnimationFrame(heroTick);
      });
      heroHost.addEventListener('mouseleave', function () {
        heroLight.style.opacity = '0';
        dTarget = 0;
        if (distorted) distorted.style.opacity = '0';
      });
    }

    /* Scroll reveals */
    var rio = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.style.opacity = '1';
          en.target.style.transform = 'translateY(0)';
          rio.unobserve(en.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('[data-k7-reveal]').forEach(function (el) {
      el.style.opacity = '';
      el.style.transform = '';
      el.style.transition = '';
      /* Elements already in the viewport on load are skipped (no flash) */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.9s ease, transform 0.9s ' + ease;
      rio.observe(el);
    });

    /* Chart draw-in: lines sweep, dots and labels fade */
    var chart = document.getElementById('k7-stability-chart');
    var chartDrawn = false;
    var drawChart = null;
    if (chart) {
      var chartLines = chart.querySelectorAll('[data-line]');
      var chartDots = chart.querySelectorAll('[data-dot]');
      chartLines.forEach(function (l) { l.style.strokeDasharray = '1'; l.style.strokeDashoffset = '1'; });
      chartDots.forEach(function (d) { d.style.opacity = '0'; });
      drawChart = function () {
        if (chartDrawn) return;
        chartDrawn = true;
        chartLines.forEach(function (l, i) {
          l.style.transition = 'stroke-dashoffset 1.6s ' + ease + ' ' + (i * 350) + 'ms';
          l.style.strokeDashoffset = '0';
        });
        chartDots.forEach(function (d, i) {
          d.style.transition = 'opacity 0.4s ease ' + (700 + i * 120) + 'ms';
          d.style.opacity = '1';
        });
      };
      var cio = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { drawChart(); cio.disconnect(); }
      }, { threshold: 0.3 });
      cio.observe(chart);
    }

    /* Scroll failsafe for reveals + chart, and gentle parallax on tagged media */
    var onScroll = function () {
      document.querySelectorAll('[data-k7-reveal]').forEach(function (el) {
        if (el.style.opacity === '0' && el.getBoundingClientRect().top < window.innerHeight * 0.95) {
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
        }
      });
      if (drawChart && !chartDrawn && chart) {
        if (chart.getBoundingClientRect().top < window.innerHeight * 0.9) drawChart();
      }
      document.querySelectorAll('[data-k7-parallax]').forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        var p = Math.max(-1, Math.min(1, (r.top + r.height / 2 - window.innerHeight / 2) / window.innerHeight));
        el.style.transform = 'translateY(' + (p * -4) + '%)';
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
